import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class UpdateBankNoteApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/bankNoteUpdate',
      requesterInfo,
    })
  }

  public async updateBankNote(request: any): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
